import useSWR from 'swr';

export const useUser = () => {
  const { data, error, isLoading, mutate } = useSWR('/users/user');

  return {
    user: data?.user,
    error,
    isLoading,
    mutate,
  };
};
